export default {
  SALE: 'sale',
  X_PERCENT_OFF: 'x%Off',
  SAVE_X_PERCENT: 'saveX%'
};
